export default "__VITE_ASSET__D5sg4gMl__"